import { Button, Result } from 'antd';
import React from 'react';

const NoPermission = () => (
  <Result
    status="403"
    title="暂无权限"
    subTitle="请联系管理员配置"
    style={{ width: '100%' }}
    extra={
      <Button type="primary" onClick={() => { window.location.href = '/litta-palmer/dashboard'; }}>
        返回主页
      </Button>
    }
  />
);

export default NoPermission;
